<div
  *ngIf="isAutoPayment; else oneTimePaymentNotification"
  class="payment-notification"
>
  <p class="payment-notification__text">
    Auto pay scheduled for
    <span class="payment-notification__amount">
      {{ amount | currency : "USD" : "symbol" : "1.2-2" }}
    </span>
    on
    <span class="payment-notification__date">
      {{ scheduledDate | date : "MMM. dd" }}</span
    >. Your account details will be updated once this payment is processed.
  </p>
  <a
    *ngIf="baseHrefUrl; else routerAutoLink"
    class="payment-notification__link--auto-pay be-btn be-btn--small be-btn--transparent-ghost"
    [href]="baseHrefUrl + '&destination=autopay&id=' + accountId"
    >Manage auto pay</a
  >
  <ng-template #routerAutoLink>
    <a
      class="payment-notification__link--auto-pay be-btn be-btn--small be-btn--transparent-ghost"
      [routerLink]="['/', 'main', 'accounts', 'payments', 'autopay']"
      >Manage auto pay</a
    >
  </ng-template>
</div>

<ng-template #oneTimePaymentNotification>
  <div class="payment-notification">
    <p class="payment-notification__text">
      One-time payment scheduled for
      <span class="payment-notification__amount">
        {{ amount | currency : "USD" : "symbol" : "1.2-2" }}
      </span>
      on
      <span class="payment-notification__date">
        {{ scheduledDate | date : "MMM. dd" }}</span
      >. Your account details will be updated once this payment is processed.
    </p>
    <a
      *ngIf="baseHrefUrl; else routerActivityLink"
      class="payment-notification__link"
      [href]="baseHrefUrl + '&destination=payment-activity&id=' + accountId"
      >Payment activity</a
    >

    <ng-template #routerActivityLink>
      <a
        class="payment-notification__link"
        [routerLink]="['/', 'main', 'accounts', 'payments', 'activity']"
        >Payment activity</a
      >
    </ng-template>
  </div>
</ng-template>
